import React from 'react'
import Parser from 'html-react-parser';

export default function KullanimSartlari() {

    const wordContent = `
    <p align=center style='text-align:center'><strong><span style='font-size:16.0pt;
font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
mso-fareast-theme-font:major-fareast;color:black'>KULLANIM ŞARTLARI<o:p></o:p></span></strong></p>

<p><span style='font-family:"Arial",sans-serif;color:black'><br>
Yürürlük Tarihi: Nisan 2025<br>
att <span class=SpellE>app'e</span> (&quot;biz,&quot; &quot;bizim,&quot; veya
&quot;bizler&quot;) hoş geldiniz. Bu Kullanım Şartları (&quot;Şartlar&quot;),
mobil uygulamamız ve web sitemiz üzerinden sunduğumuz hizmetlerin (toplu olarak
&quot;Hizmetler&quot;) kullanımınızı düzenler. Hizmetlerimizi erişim
sağladığınızda veya kullandığınızda, bu Şartlara uymayı kabul etmiş olursunuz.
Eğer bu Şartları kabul etmiyorsanız, Hizmetlerimizi kullanamazsınız.<o:p></o:p></span></p>

<p><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>Genel Bakış</span></strong><span
style='font-family:"Arial",sans-serif;color:black'><br>
Hizmetlerimiz, konum bazlı dosya paylaşımını sağlar ve arkadaş ekleme gibi
özellikler sunar. Hizmetleri kullanarak, bu Şartlarda belirtilen kurallar ve
sorumlulukları kabul etmiş olursunuz, böylece tüm kullanıcılar için güvenli ve
saygılı bir ortam sağlanır.<o:p></o:p></span></p>

<p style='margin-left:36.0pt;text-indent:-18.0pt;mso-list:l0 level1 lfo1;
tab-stops:list 36.0pt'><![if !supportLists]><span style='font-family:"Arial",sans-serif;
mso-fareast-font-family:Arial;color:black'><span style='mso-list:Ignore'>1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>Uygunluk</span></strong><span
style='font-family:"Arial",sans-serif;color:black'><br>
Hizmetlerimiz yalnızca 16 yaş ve üzeri kullanıcılar içindir. Hizmetlerimizi
kullanarak, bu yaş koşulunu karşıladığınızı onaylarsınız. 16 yaşından küçük
iseniz, Hizmetlerimizi erişim sağlamak veya kullanmak yasaktır.<o:p></o:p></span></p>

<p style='margin-left:36.0pt;text-indent:-18.0pt;mso-list:l0 level1 lfo1;
tab-stops:list 36.0pt'><![if !supportLists]><span style='font-family:"Arial",sans-serif;
mso-fareast-font-family:Arial;color:black'><span style='mso-list:Ignore'>2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>Hesap Oluşturma</span></strong><span
style='font-family:"Arial",sans-serif;color:black'><br>
Hizmetlerimizin belirli özelliklerini kullanabilmek için kullanıcı adı ve
e-posta adresiniz dahil olmak üzere doğru ve eksiksiz bilgiler sağlayarak bir
hesap oluşturmanız gerekmektedir. Hesap giriş bilgilerinizin gizliliğini
korumaktan siz sorumlusunuz ve hesabınız üzerinden gerçekleşen tüm
faaliyetlerden yalnızca siz sorumlu olursunuz. Hesabınıza yetkisiz bir
erişimden şüphelenmeniz durumunda derhal bizimle iletişime geçmelisiniz.<o:p></o:p></span></p>

<p style='margin-left:36.0pt;text-indent:-18.0pt;mso-list:l0 level1 lfo1;
tab-stops:list 36.0pt'><![if !supportLists]><span style='font-family:"Arial",sans-serif;
mso-fareast-font-family:Arial;color:black'><span style='mso-list:Ignore'>3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>Dosya
Paylaşımı ve İçerik</span></strong><span style='font-family:"Arial",sans-serif;
color:black'><br>
Hizmetlerimiz, kullanıcıların konumlarına dayalı olarak dosya paylaşmalarına
olanak tanır. Hizmetlerimiz aracılığıyla herhangi bir içerik yüklediğinizde
veya paylaştığınızda, bu işlemi gerçekleştirmek için gerekli tüm haklara ve
izinlere sahip olduğunuzu beyan etmiş olursunuz.<br>
</span><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>Yasaklı
İçerik</span></strong><span style='font-family:"Arial",sans-serif;color:black'><br>
Aşağıdaki içerikleri yüklememeyi, paylaşmamayı veya dağıtmamayı kabul
edersiniz:<br>
• Yasadışı, zararlı, tehditkar, taciz edici veya kötüleyici içerik.<br>
• Diğerlerinin fikri mülkiyet haklarını ihlal eden içerik.<br>
• Açık veya uygunsuz materyal içeren içerik.<br>
• Ayrımcılığı, nefreti veya şiddeti teşvik eden içerik.<br>
Bu Koşulları ihlal eden veya kendi takdirimize göre uygunsuz olduğuna karar
verilen herhangi bir içeriği inceleme ve gerekli gördüğümüz takdirde kaldırma
hakkını saklı tutarız.<o:p></o:p></span></p>

<p style='margin-left:36.0pt;text-indent:-18.0pt;mso-list:l0 level1 lfo1;
tab-stops:list 36.0pt'><![if !supportLists]><span style='font-family:"Arial",sans-serif;
mso-fareast-font-family:Arial;color:black'><span style='mso-list:Ignore'>4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>Veri
Toplama ve Gizlilik</span></strong><span style='font-family:"Arial",sans-serif;
color:black'><br>
Kullanıcı adınız, adınız, soyadınız ve e-posta adresiniz gibi kişisel bilgileri
toplar ve işleriz, böylece Hizmetlerimizi sunabilir ve iyileştirebilir, hesap
oluşturulmasını sağlarız, dosya paylaşımını kolaylaştırır ve arkadaş
bağlantılarını destekleriz. Hizmetlerimizi kullanarak, kişisel verilerinizin
toplanması ve kullanılmasına [Gizlilik Politikamızda] belirtildiği şekilde onay
vermiş olursunuz.<o:p></o:p></span></p>

<p style='margin-left:36.0pt;text-indent:-18.0pt;mso-list:l0 level1 lfo1;
tab-stops:list 36.0pt'><![if !supportLists]><span style='font-family:"Arial",sans-serif;
mso-fareast-font-family:Arial;color:black'><span style='mso-list:Ignore'>5.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>Kullanıcı
Davranışı</span></strong><span style='font-family:"Arial",sans-serif;
color:black'><br>
Hizmetlerimizi kullanırken, aşağıdakilere uymayı kabul edersiniz:<br>
• Hizmetleri yalnızca yasal amaçlarla kullanmak.<br>
• Diğer kullanıcıların gizliliğine ve haklarına saygı göstermek.<br>
• Hizmetlerin doğru işleyişini engelleyebilecek herhangi bir faaliyetten
kaçınmak.<o:p></o:p></span></p>

<p style='margin-left:36.0pt'><span style='font-family:"Arial",sans-serif;
color:black'>Ayrıca şunları yapmamayı kabul edersiniz:<br>
• Herhangi bir kişi veya kuruluşu taklit etmek.<br>
• Hizmetlerin yetkisiz alanlarına erişmeye çalışmak.<br>
• Zararlı yazılım, virüs veya tehlikeli yazılım içeren dosyalar yüklemek.<o:p></o:p></span></p>

<p style='margin-left:36.0pt;text-indent:-18.0pt;mso-list:l0 level1 lfo1;
tab-stops:list 36.0pt'><![if !supportLists]><span style='font-family:"Arial",sans-serif;
mso-fareast-font-family:Arial;color:black'><span style='mso-list:Ignore'>6.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>Fikri
Mülkiyet</span></strong><span style='font-family:"Arial",sans-serif;color:black'><br>
Hizmetler aracılığıyla sunulan tüm içerik, özellik ve işlevler, ancak bunlarla
sınırlı olmamak üzere metin, grafik, logo ve yazılım, bizim veya lisans
verenlerimizin mülkiyetindedir ve fikri mülkiyet yasaları ile korunmaktadır.
Önceden yazılı iznimiz olmadan bu içerikleri kopyalayamaz, çoğaltamaz,
dağıtamaz veya türev çalışmalar oluşturamazsınız.<o:p></o:p></span></p>

<p style='margin-left:36.0pt;text-indent:-18.0pt;mso-list:l0 level1 lfo1;
tab-stops:list 36.0pt'><![if !supportLists]><span style='font-family:"Arial",sans-serif;
mso-fareast-font-family:Arial;color:black'><span style='mso-list:Ignore'>7.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>Fesih</span></strong><span
style='font-family:"Arial",sans-serif;color:black'><br>
Bu Şartları ihlal etmeniz veya Hizmetlere, diğer kullanıcılara veya üçüncü
taraflara zarar verebilecek faaliyetlerde bulunmanız durumunda, Hizmetlere
erişiminizi herhangi bir zamanda, bildirimli veya bildirimsiz olarak askıya
alma veya sonlandırma hakkını saklı tutarız.<o:p></o:p></span></p>

<p style='margin-left:36.0pt;text-indent:-18.0pt;mso-list:l0 level1 lfo1;
tab-stops:list 36.0pt'><![if !supportLists]><span style='font-family:"Arial",sans-serif;
mso-fareast-font-family:Arial;color:black'><span style='mso-list:Ignore'>8.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>Garanti
Reddi</span></strong><span style='font-family:"Arial",sans-serif;color:black'><br>
Hizmetler, &quot;olduğu gibi&quot; ve &quot;mevcut olduğu şekilde&quot;
sağlanmaktadır. Tüm garanti ve beyanlardan, açık veya zımni olarak, ticari
elverişlilik, belirli bir amaca uygunluk ve <span class=SpellE>ihlalsizlik</span>
garantileri dahil olmak üzere, feragat ederiz. Hizmetlerin doğruluğu,
güvenilirliği veya kullanılabilirliği konusunda herhangi bir garanti vermeyiz.<o:p></o:p></span></p>

<p style='margin-left:36.0pt;text-indent:-18.0pt;mso-list:l0 level1 lfo1;
tab-stops:list 36.0pt'><![if !supportLists]><span style='font-family:"Arial",sans-serif;
mso-fareast-font-family:Arial;color:black'><span style='mso-list:Ignore'>9.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>Sorumluluğun
Sınırlandırılması</span></strong><span style='font-family:"Arial",sans-serif;
color:black'><br>
Yasal olarak izin verilen en geniş ölçüde, Hizmetleri kullanmanızdan
kaynaklanan dolaylı, tesadüfi, sonuçsal veya cezai zararlardan dolayı sorumlu değiliz.
Hizmetlerle ilgili herhangi bir iddia için toplam sorumluluğumuz, Hizmetlere
erişim sağlamak için bize ödediğiniz miktar ile sınırlı olacaktır.<o:p></o:p></span></p>

<p style='margin-left:36.0pt;text-indent:-18.0pt;mso-list:l0 level1 lfo1;
tab-stops:list 36.0pt'><![if !supportLists]><span style='font-family:"Arial",sans-serif;
mso-fareast-font-family:Arial;color:black'><span style='mso-list:Ignore'>10.<span
style='font:7.0pt "Times New Roman"'> </span></span></span><![endif]><span
dir=LTR></span><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>Bu
Şartlarda Değişiklikler</span></strong><span style='font-family:"Arial",sans-serif;
color:black'><br>
Hizmetlerimizdeki veya yasal gereksinimlerdeki değişiklikleri yansıtmak
amacıyla bu Şartları zaman zaman güncelleyebiliriz. Önemli değişiklikler
hakkında sizi bilgilendirmek için güncellenmiş Şartları web sitemizde veya
uygulama içinde yayınlayacağız. Bu tür güncellemelerden sonra Hizmetleri
kullanmaya devam etmeniz, <span class=GramE>revize edilmiş</span> Şartları
kabul ettiğiniz anlamına gelir.<o:p></o:p></span></p>

<p style='margin-left:36.0pt;text-indent:-18.0pt;mso-list:l0 level1 lfo1;
tab-stops:list 36.0pt'><![if !supportLists]><span style='font-family:"Arial",sans-serif;
mso-fareast-font-family:Arial;color:black'><span style='mso-list:Ignore'>11.<span
style='font:7.0pt "Times New Roman"'> </span></span></span><![endif]><span
dir=LTR></span><strong><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
"Times New Roman";mso-fareast-theme-font:major-fareast;color:black'>İletişim
Bilgileri</span></strong><span style='font-family:"Arial",sans-serif;
color:black'><br>
Bu Şartlar hakkında herhangi bir sorunuz veya endişeniz varsa, lütfen bizimle
iletişime geçin:<br>
legal@att-app.com<o:p></o:p></span></p>

<p><span style='font-family:"Arial",sans-serif;color:black'>Hizmetlerimizi
kullanarak, bu Kullanım Şartlarını okuduğunuzu, anladığınızı ve kabul
ettiğinizi onaylarsınız.<o:p></o:p></span></p>

<p class=MsoNormal><span style='font-family:"Arial",sans-serif'><o:p>&nbsp;</o:p></span></p>

    `
return (
    <div className='lg:w-1/2 p-2 text-sm my-5'>
        {Parser(wordContent)}

    </div>
) }